import {useDocumentTitle} from 'hooks/useDocumentTitle';
import {Suspense} from 'react';
import {CardManagementView} from 'views/admin/CardManagement';

export const CardManagement = () => {
  useDocumentTitle('Gratitude cards');
  return (
    <Suspense fallback={null}>
      <CardManagementView />
    </Suspense>
  );
};
